import { chatbotEnabled } from "@faire/help-center-utils/lib/chatbotEnabled";
import { browserLevelLanguage } from "@faire/help-center-utils/serialized-data/getLocale";
import { getIsLoggedInUser } from "@faire/help-center-utils/serialized-data/getUser";
import { Language } from "@faire/web-api/indigofair/languages/Language";
export var useAIChatbotAccess = function useAIChatbotAccess() {
  var isLoggedInUser = getIsLoggedInUser();
  var lang = browserLevelLanguage();
  var engOnly = lang === Language.ENG;
  return chatbotEnabled() && isLoggedInUser && engOnly;
};